/*
 Scroll and pin / unpin / unpinlocked
 - 3 states: unpinned top of container, pinned(fixed) with scroll, unpinlocked at bottom of container

 Usage:

 1. Pass the element you want to pin and the reference element it will pin against

 pinscroll.el = el;
 pinscroll.refEl = refEl;

 2. pass the top offset, attach to scroll and pin the element, pinScroll.el

 pinscroll.elTopPinPos = 125px;  //scorestrip is present
 pinscroll.elTopPinPos = 50px;  //scorestrip is not present
 pinscroll.startScroll();

 this.allAdPinned[storyIndex - 1] = true;

 3. scroll passing bottom of the reference element (pinScroll.refEl), remove pin and lock the pinScroll.el at the bottom

 */

import Viewports from '../../fsUtils/Viewports';
import scrollEvent from "../../fsUtils/scrollEvent";

if (typeof viewports === "undefined") {
    var viewports = new Viewports();
}

angular.module('storyApp').factory('adPinScroll', ['storyScroll', function(storyScroll) {

    var pinScroll = {

        isPinned: false,
        isUnPinLocked: false,

        //element to pin references
        el: undefined,
        elTopPinPos: undefined,
        pinPosBelowSecNav: 106,
        elBottomPinPos: undefined,
        elBottomOffset: 20,
        unPinOffSet: 145,
        lastScrollPos: 0,
        elLockedBottomPinPos: undefined,
        elInnerContainer: undefined,
        docW: viewports.docW,
        rightPos: ((viewports.docW - 1280) / 2), //document width minus content block width of 1280 divide by 2

        //reference elements
        refEl: undefined,
        refTopPos: undefined,
        refBottomPos: undefined,
        bodyClassList: document.body.classList,

        /**
         * init function to initialize the pinScroll object properties
         * @param Object el - Dom object selector to be checked onScroll
         * @param Object refEl - Dom object selector to be compared with el onScroll
         * el will be injected inline pining and un-pining styles onScroll
         **/
        init: function(el, refEl) {
            this.el = el;
            this.refEl = refEl;
            this.elInnerContainer = this.el && this.el.children[0];

            return this;
        },
        /**
         * @desc get banner ad overlay height
         * @return Number
         */
        getBannerAdOverlayHeight: function() {
            var adSizeAttr = document.querySelector('[data-banner-ad-size]');
            var adSize = adSizeAttr && adSizeAttr.getAttribute("data-banner-ad-size");
            var offsetNoSec = (this.bodyClassList.contains('no-secondary')) ? 40 : 0;
            var offsetNoBannerPin = (!this.bodyClassList.contains('banner-ad-pin')) ? 110 : 0;

            if (adSize === "728,90" || adSize === "970,250") {
                adSize = 218;
            } else if (adSize === "980,50") {
                adSize = 70;
            } else {
                adSize = 0;
            }
            return adSize + offsetNoSec - offsetNoBannerPin;
        },
        /**
         * @desc updating pin. check if el is pinned
         * @param bool pinnedVal - true or false
         * @return undefined - this.render() runs once
         */
        updatePinned: function(pinnedVal, top) {

            if (this.isPinned != pinnedVal) {
                this.isPinned = pinnedVal;
                this.render(top);
            }

        },
        /**
         * @desc check if el is locked
         * @param bool unPinLockedVal - true or false
         * @return undefined - this.render() runs once
         */
        updateUnPinLocked: function(unPinLockedVal, pinPos) {

            if (this.isUnPinLocked != unPinLockedVal) {
                this.isUnPinLocked = unPinLockedVal;
                this.render(pinPos);
            }

        },
        /** @desc check element top and bottom positions.
         * if reference el scroll top position (this.refTopPos) less and equal than the pin top position (this.elTopPinPos),
         * set this.isPinned to true; otherwise, set is to false.
         * if reference el scroll bottom position (this.refBottomPos) less and equal than elBottomValue (this.el.clientHeight),
         * set this.isUnPinLocked to true; otherwise, set is to false
         * **/
        checkOnScroll: function() {


            var pinPos = this.elTopPinPos + this.getBannerAdOverlayHeight();

            //if pin top
            (this.refTopPos <= pinPos) ? this.updatePinned(true, pinPos): this.updatePinned(false, pinPos);

            // check if unpinned locked (relative to scroll)
            //assign new bottom value when reached bottom
            var elBottomValue = (this.elLockedBottomPinPos) ? this.elLockedBottomPinPos : this.elBottomPinPos;
            if (this.refBottomPos <= elBottomValue + this.unPinOffSet) {
                this.elLockedBottomPinPos = elBottomValue;
                //update bottom locked position
                this.updateUnPinLocked(true, false);
            } else {
                //unlock bottom position
                this.updateUnPinLocked(false, pinPos);
            }

        },
        /** @desc event binding onScroll. Set this.refTopPos, this.refBottomPos and this.elBottomPinPos positions. **/
        handleScroll: function() {

            this.refTopPos = (this.refEl) ? Math.round(this.refEl.getBoundingClientRect().top) : this.refTopPos;
            this.refBottomPos = (this.refEl) ? Math.round(this.refEl.getBoundingClientRect().bottom) : this.refBottomPos;

            this.elBottomPinPos = this.elInnerContainer.clientHeight;

            this.checkOnScroll();

        },
        startPinning: function() {

            //scroll event
            window.addEventListener('scroll', this.handleScroll.bind(this));

            //window resize event
            window.addEventListener('resize', scrollEvent.throttle(this.resetOnResize.bind(this), 200));

        },
        stopPinning: function() {
            window.removeEventListener('scroll', this.handleScroll.bind(this));
        },
        /** @desc update element inline styles, pin on top or lock on bottom **/
        render: function(pinPos) {
            var st = window.pageYOffset;
            var scrollDirection = (st > this.lastScrollPos) ? 'down' : 'up';
            var styleText = '';
            //if isPinned is set to be true and pinPos, set pin position
            if (this.isPinned && pinPos) {
                //pin top styles
                if (this.prevTopPos > pinPos && scrollDirection === 'up' && this.bodyClassList.contains('right-rail-transform')) pinPos = this.prevTopPos;
                //on window width over 1280px, add right position
                if (this.docW > 1280) {
                    styleText = 'position:fixed;top:' + pinPos + 'px;bottom:auto;right:' + this.rightPos + 'px;';
                    //on window width less than 1280px, add right position will be 0
                } else {
                    styleText = 'position:fixed;top:' + pinPos + 'px;right:0;';
                }
                this.prevTopPos = pinPos;

                //otherwise, set bottom locked position
            } else
            if (this.isUnPinLocked) {

                var bottomPos = this.elBottomPinPos - this.elBottomOffset;
                //lock on bottom styles
                styleText = 'position:absolute;top:auto;bottom:' + bottomPos + 'px;right:0';
                this.bodyClassList.remove('right-rail-transform');

            } else if (this.bodyClassList.contains('right-rail-transform')) {

                this.bodyClassList.remove('right-rail-transform');
            }

            this.lastScrollPos = st;
            //this.el style will be set pin position, bottom locked position, or empty style
            this.el && (this.el.style.cssText = styleText);

        },

        /*
         * on Window resize
         * 1) clear the right rail pining style: reset this.el.style.cssText = ""
         * 2) set the new doc width for this.docW: this.docW = document.body.clientWidth;
         * 3) set the new top right position: ((that.docW - 1280) / 2 );
         */
        resetOnResize: function() {

            this.el.style.cssText = "";

            this.docW = document.body.clientWidth;

            this.rightPos = ((this.docW - 1280) / 2);

            viewports.setDocW(this.docW);

        }
    }


    return pinScroll;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/adPinScroll.js